module.exports = __webpack_public_path__ + "static/img/loading.3b151cd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/sigen/library/loading.gif
// module id = aKmK
// module chunks = 5